import React from 'react';
import styled from 'styled-components';
import ItemBox from './ItemFilterCheckBox';
import { ICommonCode } from 'utils/types/storyTypes';

interface IProps {
  filterList: ICommonCode[];
  setItemFilter: React.Dispatch<React.SetStateAction<string[]>>;
  itemFilter: string[];
}

const ItemTypeFilterModal: React.FC<IProps> = ({
  filterList,
  itemFilter,
  setItemFilter,
}) => {
  // TODO 아이.. 대체 몇단계를 거치는거야 미친..
  return (
    <Wrapper>
      {filterList?.map((el, i) => {
        return (
          <ItemBox
            key={i}
            data={el}
            itemFilter={itemFilter}
            setItemFilter={setItemFilter}
          />
        );
      })}
    </Wrapper>
  );
};

export default ItemTypeFilterModal;

const Wrapper = styled.div`
  position: absolute;
  bottom: 100;
  left: 0;
  width: fit-content;
  padding: 16px;
  box-shadow: rgba(103, 146, 244, 0.5) 0px 1px 4px 0px;
  border-radius: 8px;
  background-color: #ffffff;
  z-index: 1;
`;
